import { useState, useRef } from 'react'
import { validateSowFile } from '../utils/fileValidation'

export default function RaidUploadCard({ onSubmit }) {
  const [sowFile, setSowFile]           = useState(null)
  const [isDragging, setIsDragging]     = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const sowInputRef = useRef(null)

  function handleDragOver(e) { e.preventDefault(); setIsDragging(true) }
  function handleDragLeave(e) { if (!e.currentTarget.contains(e.relatedTarget)) setIsDragging(false) }

  function handleDrop(e) {
    e.preventDefault()
    setIsDragging(false)
    const file = e.dataTransfer?.files[0]
    if (!file) return
    const err = validateSowFile(file)
    if (err) { alert(err); return }
    setSowFile(file)
  }

  function handleSowChange(e) {
    const file = e.target.files[0]
    if (!file) return
    const err = validateSowFile(file)
    if (err) { alert(err); return }
    setSowFile(file)
  }
  function handleZoneClick() { sowInputRef.current?.click() }
  function handleZoneKeyDown(e) { if (e.key === 'Enter' || e.key === ' ') sowInputRef.current?.click() }

  async function handleAnalyse() {
    if (!sowFile || isSubmitting) return
    setIsSubmitting(true)
    await onSubmit(sowFile)
    setIsSubmitting(false)
  }

  function formatSize(bytes) {
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  }

  const dzClass = ['c-dropzone', isDragging ? 'drag-over' : '', sowFile ? 'has-file' : ''].filter(Boolean).join(' ')

  return (
    <div className="c-card">
      <div className="c-card-title">📤 &nbsp;Upload SOW document</div>
      <div className="c-card-desc">
        Accepted formats: <strong>.docx</strong> or <strong>.pdf</strong>.
        The AI will analyse the SOW and populate the RAID tracker with identified risks.
      </div>

      <div
        className={dzClass}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleZoneClick}
        onKeyDown={handleZoneKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Upload SOW document"
      >
        <input ref={sowInputRef} type="file" accept=".docx,.pdf" onChange={handleSowChange} style={{ display: 'none' }} />

        {sowFile ? (
          <div className="dz-file-info">
            <span className="dz-file-icon">📋</span>
            <div>
              <div className="dz-file-name">{sowFile.name}</div>
              <div className="dz-file-change">{formatSize(sowFile.size)} &nbsp;·&nbsp; Click to change</div>
            </div>
          </div>
        ) : (
          <div>
            <div className="dz-icon">📄</div>
            <div className="dz-text">Drop your SOW here, or click to browse</div>
            <div className="dz-hint">.docx / .pdf &nbsp;· up to 50 MB</div>
          </div>
        )}
      </div>

      <button className="c-btn-primary" disabled={!sowFile || isSubmitting} onClick={handleAnalyse}>
        {isSubmitting
          ? <><span className="c-spinner c-spinner-white" /> Uploading…</>
          : 'Analyse RAID Risks'
        }
      </button>
    </div>
  )
}
